(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mn-setup-planner"] && !Shopify.designMode) return;
  try {
    
/*
 * Mapping Network Setup Planner: live blueprint diagram.
 *
 * draw(input, result) returns an SVG string that redraws the install the
 * customer is describing: a close-up of a window for indoor setups, or a
 * cut-away house for attic, outside-wall and roof setups, with the
 * surroundings (city, suburbs, countryside, hills) in the background. Every
 * suggested part gets a numbered callout that matches the parts list.
 *
 * Pure string building (no DOM), so it is unit tested in Node. Colours come
 * from CSS classes (.bp-*) so the theme editor can switch between a blue
 * blueprint and a black-and-white drawing.
 */
(function (global) {
  'use strict';

  var W = 640, H = 400;

  function f(n) { return Math.round(n * 10) / 10; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function line(x1, y1, x2, y2, cls) { return '<line x1="' + f(x1) + '" y1="' + f(y1) + '" x2="' + f(x2) + '" y2="' + f(y2) + '" class="' + (cls || 'bp-s') + '"/>'; }
  function path(d, cls, extra) { return '<path d="' + d + '" class="' + (cls || 'bp-s') + '"' + (extra || '') + '/>'; }
  // The signal path: a solid line that draws itself in, with a flow of dashes on top (CSS animates both).
  function sig(d, flat) {
    return '<path d="' + d + '" pathLength="1" class="bp-sig-draw' + (flat ? ' bp-flat' : '') + '"/>' +
      (flat ? '' : '<path d="' + d + '" class="bp-sig-flow"/>');
  }
  function rect(x, y, w, h, cls, rx) { return '<rect x="' + f(x) + '" y="' + f(y) + '" width="' + f(w) + '" height="' + f(h) + '"' + (rx ? ' rx="' + rx + '"' : '') + ' class="' + (cls || 'bp-s') + '"/>'; }
  function circle(cx, cy, r, cls) { return '<circle cx="' + f(cx) + '" cy="' + f(cy) + '" r="' + r + '" class="' + (cls || 'bp-s') + '"/>'; }
  function text(x, y, s, cls, anchor) { return '<text x="' + f(x) + '" y="' + f(y) + '" class="' + (cls || 'bp-t') + '"' + (anchor ? ' text-anchor="' + anchor + '"' : '') + '>' + esc(s) + '</text>'; }
  function poly(pts) { return pts.map(function (p, i) { return (i ? 'L' : 'M') + f(p[0]) + ' ' + f(p[1]); }).join(' '); }

  // ------------------------------------------------------------ surroundings

  /** Silhouettes of the surroundings between x0 and x1, standing on groundY. */
  function backdrop(env, x0, x1, groundY, k) {
    k = k || 1;
    var out = [];
    var span = x1 - x0;
    if (env === 'city') {
      var hs = [70, 110, 55, 135, 85, 120, 60, 95];
      var n = Math.max(3, Math.round(span / (34 * k)));
      var bw = span / n;
      for (var i = 0; i < n; i++) {
        var bh = hs[i % hs.length] * k;
        var bx = x0 + i * bw + 3;
        out.push(rect(bx, groundY - bh, bw - 6, bh, 'bp-far'));
        for (var wy = groundY - bh + 10 * k; wy < groundY - 8 * k; wy += 14 * k) {
          out.push(line(bx + 5, wy, bx + bw - 11, wy, 'bp-far bp-faint'));
        }
      }
    } else if (env === 'suburban') {
      var step = 78 * k;
      for (var hx = x0 + 6; hx + 44 * k < x1; hx += step) {
        var w = 40 * k, h = 24 * k;
        out.push(path(poly([[hx, groundY], [hx, groundY - h], [hx + w / 2, groundY - h - 16 * k], [hx + w, groundY - h], [hx + w, groundY], [hx, groundY]]), 'bp-far'));
        out.push(rect(hx + w * 0.38, groundY - 12 * k, w * 0.24, 12 * k, 'bp-far'));
        var tx = hx + w + 16 * k;
        if (tx + 10 * k < x1) {
          out.push(line(tx, groundY, tx, groundY - 14 * k, 'bp-far'));
          out.push(circle(tx, groundY - 24 * k, 11 * k, 'bp-far'));
        }
      }
    } else if (env === 'rural') {
      out.push(line(x0, groundY - 2, x1, groundY - 2, 'bp-far bp-faint'));
      for (var px = x0 + 4; px < x1; px += 22 * k) out.push(line(px, groundY, px, groundY - 10 * k, 'bp-far'));
      out.push(line(x0, groundY - 7 * k, x1, groundY - 7 * k, 'bp-far'));
      var bx2 = x0 + span * 0.55;
      if (bx2 + 50 * k < x1) {
        out.push(path(poly([[bx2, groundY], [bx2, groundY - 26 * k], [bx2 + 18 * k, groundY - 40 * k], [bx2 + 36 * k, groundY - 26 * k], [bx2 + 36 * k, groundY]]), 'bp-far'));
        out.push(rect(bx2 + 40 * k, groundY - 52 * k, 12 * k, 52 * k, 'bp-far', 5));
      }
    } else if (env === 'hilly') {
      out.push(path('M' + f(x0) + ' ' + f(groundY) + ' Q ' + f(x0 + span * 0.25) + ' ' + f(groundY - 120 * k) + ' ' + f(x0 + span * 0.5) + ' ' + f(groundY - 30 * k) + ' T ' + f(x1) + ' ' + f(groundY - 50 * k), 'bp-far'));
      out.push(path('M' + f(x0 + span * 0.15) + ' ' + f(groundY) + ' Q ' + f(x0 + span * 0.6) + ' ' + f(groundY - 80 * k) + ' ' + f(x1) + ' ' + f(groundY - 10 * k), 'bp-far bp-faint'));
    }
    return out.join('');
  }

  // ------------------------------------------------------------ parts

  function antennaShape(x, baseY, directional) {
    if (directional) {
      return rect(x - 6, baseY - 46, 12, 46, 'bp-s bp-paper', 2) +
        line(x - 2, baseY - 40, x - 2, baseY - 6, 'bp-s bp-faint') +
        path('M' + (x + 10) + ' ' + (baseY - 30) + ' l 22 -8 M' + (x + 10) + ' ' + (baseY - 23) + ' l 26 0 M' + (x + 10) + ' ' + (baseY - 16) + ' l 22 8', 'bp-s bp-faint');
    }
    return rect(x - 3, baseY - 62, 6, 56, 'bp-s bp-paper', 3) + rect(x - 4.5, baseY - 6, 9, 6, 'bp-s');
  }

  function antennaShapeLen(x, baseY, len) {
    return rect(x - 3, baseY - len - 6, 6, len, 'bp-s bp-paper', 3) + rect(x - 4.5, baseY - 6, 9, 6, 'bp-s');
  }

  function hotspotBox(x, y, label) {
    // x,y = top-left; 46 x 20
    return rect(x, y, 46, 20, 'bp-s bp-paper', 3) +
      circle(x + 8, y + 10, 1.8, 'bp-fill') + circle(x + 14, y + 10, 1.8, 'bp-fill') +
      text(x + 23, y + 34, label, 'bp-t bp-small', 'middle');
  }

  function groundRod(x, groundY) {
    return line(x, groundY, x, groundY + 16, 'bp-s') +
      line(x - 8, groundY + 16, x + 8, groundY + 16) + line(x - 5, groundY + 20, x + 5, groundY + 20) + line(x - 2, groundY + 24, x + 2, groundY + 24);
  }

  function arrestorBox(x, y) { return rect(x - 7, y - 10, 14, 20, 'bp-s bp-paper', 2) + line(x - 3, y - 3, x + 3, y + 3, 'bp-s'); }

  function enclosureBox(x, y) {
    // x,y = top-left; 40 x 52
    return rect(x, y, 40, 52, 'bp-s bp-paper', 3) + line(x + 6, y + 8, x + 34, y + 8, 'bp-s bp-faint') +
      hotspotMini(x + 9, y + 20);
  }
  function hotspotMini(x, y) { return rect(x, y, 22, 12, 'bp-s', 2) + circle(x + 5, y + 6, 1.4, 'bp-fill'); }

  // ------------------------------------------------------------ scenes

  /** Close-up of a window from inside the room. */
  function sceneIndoor(input, has) {
    var o = [];
    var a = {};
    // wall around the window
    o.push(rect(0, 0, W, 300, 'bp-hatch'));
    o.push('<rect x="150" y="40" width="280" height="226" class="bp-bg"/>');
    // view through the window
    o.push('<g clip-path="url(#mnsp-win)">' + backdrop(input.environment, 156, 424, 236, 0.75) +
      line(150, 236, 430, 236, 'bp-far') + '</g>');
    o.push(rect(150, 40, 280, 226, 'bp-s'));
    o.push(rect(158, 48, 128, 210, 'bp-s bp-faint'));
    o.push(rect(294, 48, 128, 210, 'bp-s bp-faint'));
    o.push(line(290, 40, 290, 266, 'bp-s'));
    // sill
    o.push(rect(132, 266, 316, 14, 'bp-s bp-paper'));
    // room: floor, desk
    o.push(rect(0, 300, W, 100, 'bp-bg'));
    o.push(line(0, 372, W, 372, 'bp-s'));
    o.push(line(450, 330, 630, 330) + line(462, 330, 462, 372) + line(618, 330, 618, 372));
    // antenna standing on the sill
    var ax = 350;
    if (has.mount) o.push('<ellipse cx="' + ax + '" cy="262" rx="16" ry="4" class="bp-s bp-paper"/>');
    o.push(antennaShape(ax, has.mount ? 258 : 262, false));
    a.antenna = [ax, 222]; a.mount = [ax + 14, 262];
    // cable: antenna base, over the sill, down to the desk and the hotspot
    var hx = 500, hy = 310;
    o.push(sig('M' + ax + ' 266 L' + ax + ' 274 Q ' + ax + ' 280 ' + (ax + 8) + ' 280 L 448 280 Q 460 280 460 292 L 460 312 Q 460 320 ' + (hx - 10) + ' 320 L ' + hx + ' 320', false));
    a.cable = [460, 300];
    o.push(hotspotBox(hx, hy, has.hotspot ? 'HOTSPOT' : 'YOUR HOTSPOT'));
    a.hotspot = [hx + 23, hy];
    o.push(path('M' + (hx + 46) + ' 320 L 600 320 L 600 346', 'bp-eth'));
    o.push(text(626, 362, 'TO ROUTER', 'bp-t bp-small', 'end'));
    o.push(text(290, 30, 'WINDOW ABOUT ' + input.heightM + ' M ABOVE GROUND', 'bp-t bp-small', 'middle'));
    return { svg: o.join(''), anchors: a };
  }

  /** Cut-away house with the antenna in the attic, on an outside wall or on the roof. */
  function sceneHouse(input, has, result) {
    var o = [];
    var a = {};
    var G = 340, CEIL = 236, PEAK = 150;
    var SLOPE = (CEIL + 12 - PEAK) / 122; // roof line from (250, PEAK) to (372, CEIL + 12)
    function roofY(x) { return PEAK + Math.abs(x - 250) * SLOPE; }
    var loc = input.location;
    var outside = loc !== 'attic' && input.hotspotPlacement === 'outside';
    var windowRoute = !outside && loc !== 'attic' && input.route === 'window';
    var directional = !!(result && result.directional);
    var h = input.heightM;

    o.push(backdrop(input.environment, 400, 630, G, 1));
    o.push(backdrop(input.environment, 4, 112, G, 0.8));
    // ground
    o.push(line(0, G, W, G, 'bp-s'));
    for (var gx = 6; gx < W; gx += 14) o.push(line(gx, G + 2, gx - 8, G + 10, 'bp-s bp-faint'));
    // house cross-section: walls 148-160 and 340-352
    o.push(rect(148, CEIL, 12, G - CEIL, 'bp-hatch-s'));
    o.push(rect(340, CEIL, 12, G - CEIL, 'bp-hatch-s'));
    if (windowRoute) {
      o.push('<rect x="339" y="262" width="14" height="38" class="bp-bg"/>');
      o.push(line(346, 262, 346, 300, 'bp-s bp-faint') + line(336, 262, 356, 262) + line(334, 300, 358, 300));
    }
    o.push(line(148, CEIL, 352, CEIL, 'bp-s'));
    o.push(path('M128 ' + (CEIL + 12) + ' L250 ' + PEAK + ' L372 ' + (CEIL + 12), 'bp-s bp-roof'));
    // table inside
    o.push(line(244, 316, 332, 316) + line(250, 316, 250, G) + line(326, 316, 326, G));

    var antX, antBase, antLen = 56;
    if (loc === 'roof') {
      var mast = Math.min(Math.max(30 + h * 2.4, 40), 76);
      antX = 250; antBase = PEAK - mast;
      o.push(rect(247, antBase, 6, mast + 4, 'bp-s bp-paper'));
      o.push(path('M236 ' + (PEAK + 6) + ' L264 ' + (PEAK + 6) + ' M240 ' + (PEAK - 6) + ' l0 14 M260 ' + (PEAK - 6) + ' l0 14', 'bp-s'));
      a.mount = [262, PEAK - 2, 40, 6];
    } else if (loc === 'attic') {
      antX = 276; antBase = CEIL - 8; antLen = 44;
      o.push(path('M' + (antX + 20) + ' ' + f(roofY(antX + 20) + 2) + ' L' + (antX + 20) + ' ' + (antBase - 22) + ' L' + (antX + 3) + ' ' + (antBase - 22), 'bp-s'));
      a.mount = [antX + 20, antBase - 30];
    } else {
      // outside wall: the bracket height follows the slider (drawing not to scale)
      antX = 396;
      var bracketY = Math.min(Math.max(G - 30 - h * 12, 236), 262);
      antBase = bracketY + 18;
      o.push(path('M352 ' + bracketY + ' L' + (antX - 3) + ' ' + bracketY + ' M352 ' + (bracketY - 10) + ' L352 ' + (bracketY + 10), 'bp-s'));
      a.mount = [372, bracketY];
    }
    o.push(directional ? antennaShape(antX, antBase, true) : antennaShapeLen(antX, antBase, antLen));
    a.antenna = [antX, antBase - antLen * 0.6];

    var arrX, arrY, gnd;
    if (outside) {
      // enclosure beside the antenna; Ethernet with PoE runs into the house to the injector
      var ex, ey, eth;
      var exIn; // x where the pigtail enters the enclosure
      if (loc === 'roof') {
        // enclosure on the left of the mast, Ethernet down the left roof and wall
        arrX = antX; arrY = antBase + 16; ex = 194; ey = antBase + 6; exIn = ex + 40;
        eth = 'M214 ' + (ey + 52) + ' L214 ' + f(roofY(214) - 5) + ' L138 ' + f(roofY(138) - 5) + ' L138 328 L300 328 L300 316';
      } else {
        arrX = antX; arrY = antBase + 16; ex = 420; ey = antBase + 2;
        var yr = Math.min(ey + 62, 332);
        eth = 'M440 ' + (ey + 52) + ' L440 ' + yr + ' L300 ' + yr + ' L300 316';
        exIn = ex;
      }
      o.push(enclosureBox(ex, ey));
      o.push(sig('M' + antX + ' ' + antBase + ' L' + antX + ' ' + (arrY - 10) + ' M' + antX + ' ' + (arrY + 10) + ' L' + antX + ' ' + (arrY + 16) + ' L' + exIn + ' ' + (arrY + 16), false));
      if (has.arrestor) o.push(arrestorBox(arrX, arrY));
      o.push(path(eth, 'bp-eth'));
      o.push(rect(282, 306, 36, 10, 'bp-s bp-paper', 2));
      o.push(text(288, 300, 'POE INJECTOR', 'bp-t bp-small', 'end'));
      o.push(text(206, G - 12, 'TO ROUTER', 'bp-t bp-small', 'end'));
      o.push(path('M282 311 L210 311 L210 ' + (G - 24), 'bp-eth'));
      var left = loc === 'roof';
      a.enclosure = left ? [ex, ey + 40, -30, 14] : [ex + 40, ey + 40, 30, 14];
      a.hotspot = left ? [ex + 11, ey + 24, -40, -26] : [ex + 31, ey + 24, 36, -20];
      a.arrestor = left ? [arrX + 7, arrY, 34, -8] : [arrX - 7, arrY, -36, -8];
      a.adaptor = left ? [arrX + 7, arrY + 8, 34, 18] : [arrX - 7, arrY + 8, -36, 18];
      a.cable = null;
    } else {
      var hx = 262, hy = 296, portY = 306;
      o.push(hotspotBox(hx, hy, has.hotspot ? 'HOTSPOT' : 'YOUR HOTSPOT'));
      a.hotspot = [hx + 23, hy];
      var cable, flat = null;
      if (loc === 'attic') {
        arrX = 318; arrY = 266;
        cable = 'M' + antX + ' ' + antBase + ' L' + antX + ' ' + (CEIL + 8) + ' Q' + antX + ' ' + (CEIL + 14) + ' ' + (antX + 6) + ' ' + (CEIL + 14) + ' L' + (arrX - 6) + ' ' + (CEIL + 14) + ' Q' + arrX + ' ' + (CEIL + 14) + ' ' + arrX + ' ' + (CEIL + 20) + ' L' + arrX + ' ' + (arrY - 10) +
          ' M' + arrX + ' ' + (arrY + 10) + ' L' + arrX + ' ' + (portY - 6) + ' Q' + arrX + ' ' + portY + ' ' + (arrX - 6) + ' ' + portY + ' L' + (hx + 46) + ' ' + portY;
        a.cable = [antX + 22, CEIL + 14];
        a.windowpass = [arrX, arrY + 22];
        gnd = 'M' + (arrX + 7) + ' ' + arrY + ' L332 ' + arrY + ' L332 ' + G;
        o.push(groundRod(332, G));
      } else {
        var downX = loc === 'roof' ? 366 : antX;
        arrX = downX; arrY = loc === 'roof' ? 270 : Math.min(antBase + 16, 288);
        var top = loc === 'roof'
          ? 'M' + antX + ' ' + antBase + ' L' + antX + ' ' + (antBase + 8) + ' L258 ' + (antBase + 8) + ' L258 ' + (PEAK - 6) + ' L366 ' + f(roofY(366) - 6) + ' L366 ' + (arrY - 10)
          : 'M' + antX + ' ' + antBase + ' L' + antX + ' ' + (arrY - 10);
        var entryY = windowRoute ? 303 : portY;
        var after = ' M' + downX + ' ' + (arrY + 10) + ' L' + downX + ' ' + (entryY - 6) + ' Q' + downX + ' ' + entryY + ' ' + (downX - 6) + ' ' + entryY + ' L' + (hx + 46) + ' ' + entryY;
        if (windowRoute) { cable = top; flat = after; }
        else cable = top + after;
        a.cable = loc === 'roof' ? [314, f(roofY(314) - 6)] : [antX, (antBase + arrY) / 2];
        a.windowpass = [346, entryY];
        gnd = 'M' + (downX + 7) + ' ' + arrY + ' L' + (downX + 18) + ' ' + arrY + ' L' + (downX + 18) + ' ' + G;
        o.push(groundRod(downX + 18, G));
        if (!windowRoute) o.push(circle(346, portY, 3, 'bp-s'));
      }
      o.push(sig(cable, false));
      if (flat) o.push(sig(flat, true));
      if (has.arrestor) { o.push(arrestorBox(arrX, arrY)); o.push(path(gnd, 'bp-gnd')); }
      a.arrestor = [arrX, arrY];
      a.adaptor = [arrX, arrY + 8];
      o.push(path('M' + hx + ' 312 L210 312 L210 ' + (G - 24), 'bp-eth'));
      o.push(text(206, G - 12, 'TO ROUTER', 'bp-t bp-small', 'end'));
    }
    if (outside && has.arrestor) {
      // bond the arrestor to ground: down the mast and wall (roof) or straight down the wall
      var gpath = loc === 'roof'
        ? 'M' + (arrX + 7) + ' ' + arrY + ' L258 ' + arrY + ' L258 ' + (PEAK - 4) + ' L380 ' + (CEIL + 8) + ' L380 ' + G
        : 'M' + (arrX - 7) + ' ' + arrY + ' L376 ' + arrY + ' L376 ' + G;
      o.push(path(gpath, 'bp-gnd'));
      o.push(groundRod(loc === 'roof' ? 380 : 376, G));
    }

    // height dimension
    var dimX = loc === 'wall' ? 500 : 470;
    var dimTop = antBase;
    o.push(line(dimX, G, dimX, dimTop, 'bp-dim') + line(dimX - 6, dimTop, dimX + 6, dimTop, 'bp-s') + line(dimX - 6, G, dimX + 6, G, 'bp-s'));
    o.push(path('M' + dimX + ' ' + dimTop + ' l -4 8 l 8 0 z M' + dimX + ' ' + G + ' l -4 -8 l 8 0 z', 'bp-fill'));
    o.push(line(antX + 10, dimTop, dimX - 8, dimTop, 'bp-dim'));
    o.push('<rect x="' + (dimX - 24) + '" y="' + f((G + dimTop) / 2 - 10) + '" width="48" height="18" class="bp-bg"/>');
    o.push(text(dimX, (G + dimTop) / 2 + 3, h + ' M', 'bp-t', 'middle'));
    return { svg: o.join(''), anchors: a };
  }

  // ------------------------------------------------------------ callouts

  var ROLE_ANCHOR = {
    antenna_low: 'antenna', antenna_mid: 'antenna', antenna_high: 'antenna', antenna_directional: 'antenna',
    cable_rpsma: 'cable', cable_nm: 'cable', window_pass: 'windowpass', window_pass_nm: 'windowpass',
    arrestor: 'arrestor', arrestor_nf: 'arrestor', adaptor_nm_nm: 'adaptor',
    mount_indoor: 'mount', mount_wall: 'mount', mount_mast: 'mount',
    enclosure_m1: 'enclosure', enclosure_gateway: 'enclosure', enclosure_bobcat: 'enclosure',
    hotspot_m1: 'hotspot', hotspot_nebra: 'hotspot'
  };
  // Where each callout bubble sits relative to its anchor.
  var OFFSET = {
    antenna: [40, -30], cable: [-40, 10], windowpass: [40, 34], arrestor: [40, -14], adaptor: [40, 18],
    mount: [-40, -14], enclosure: [34, 18], hotspot: [-34, -26]
  };

  function anchorKey(role) { return ROLE_ANCHOR[role] || null; }

  function callouts(items, anchors, vb) {
    var x0 = vb[0], y0 = vb[1], x1 = vb[0] + vb[2], y1 = vb[1] + vb[3];
    var out = [];
    var used = {};
    var placed = [];
    items.forEach(function (it, i) {
      var key = anchorKey(it.role);
      var at = key && anchors[key];
      if (!at) return;
      var off = at.length > 2 ? [at[2], at[3]] : (OFFSET[key] || [30, -20]);
      var n = (used[key] = (used[key] || 0) + 1);
      var bx = Math.min(Math.max(at[0] + off[0] + (n - 1) * 22, x0 + 14), x1 - 14);
      var by = Math.min(Math.max(at[1] + off[1], y0 + 14), y1 - 60);
      // keep bubbles from sitting on top of each other
      for (var tries = 0; tries < 8 && placed.some(function (q) { return Math.abs(q[0] - bx) < 24 && Math.abs(q[1] - by) < 24; }); tries++) {
        by += by > y1 - 90 ? -26 : 26;
      }
      placed.push([bx, by]);
      out.push('<g class="bp-callout" data-n="' + (i + 1) + '" style="--i:' + i + '">' + line(at[0], at[1], bx, by, 'bp-lead') +
        circle(at[0], at[1], 2.5, 'bp-accent-fill') + circle(bx, by, 11, 'bp-tag') +
        '<text x="' + f(bx) + '" y="' + f(by + 4) + '" text-anchor="middle" class="bp-tag-t">' + (i + 1) + '</text></g>');
    });
    return out.join('');
  }

  var LOC_LABEL = { indoor: 'INDOORS AT A WINDOW', attic: 'ATTIC', wall: 'OUTSIDE WALL', roof: 'ROOF / MAST' };
  var ENV_LABEL = { city: 'DENSE CITY', suburban: 'SUBURBS / TOWN', rural: 'OPEN COUNTRYSIDE', hilly: 'HILLS / VALLEYS' };

  function describe(input, result) {
    var parts = (result.chain || []).join(', then ');
    return 'Diagram of the setup: antenna ' + (LOC_LABEL[input.location] || '').toLowerCase() + ', surroundings ' +
      (ENV_LABEL[input.environment] || '').toLowerCase() + '. Signal path: ' + parts + '.';
  }

  /**
   * input: the planner's form input. result: recommend() output (items, chain).
   * Returns an SVG string.
   */
  function draw(input, result) {
    result = result || { items: [], chain: [] };
    var has = {};
    (result.items || []).forEach(function (it) { var k = anchorKey(it.role); if (k) has[k] = true; });
    var directional = (result.items || []).some(function (it) { return it.role === 'antenna_directional'; });
    var scene = input.location === 'indoor'
      ? sceneIndoor(input, has)
      : sceneHouse(input, has, { directional: directional });
    var desc = describe(input, result);
    // Zoom in on low installs (wall, attic) so the house fills the frame; same 8:5 shape for every scene.
    var vb = input.location === 'wall' || input.location === 'attic' ? [64, 80, 512, 320] : [0, 0, W, H];
    return '<svg class="mnsp-bp__svg" viewBox="' + vb.join(' ') + '" role="img" aria-labelledby="mnsp-bp-d" xmlns="http://www.w3.org/2000/svg">' +
      '<desc id="mnsp-bp-d">' + esc(desc) + '</desc>' +
      '<defs>' +
        '<pattern id="mnsp-grid" width="20" height="20" patternUnits="userSpaceOnUse"><path d="M20 0 L0 0 0 20" class="bp-grid"/></pattern>' +
        '<pattern id="mnsp-grid5" width="100" height="100" patternUnits="userSpaceOnUse"><path d="M100 0 L0 0 0 100" class="bp-grid bp-grid--major"/></pattern>' +
        '<pattern id="mnsp-hatch" width="8" height="8" patternUnits="userSpaceOnUse" patternTransform="rotate(45)"><line x1="0" y1="0" x2="0" y2="8" class="bp-hatchline"/></pattern>' +
        '<clipPath id="mnsp-win"><rect x="150" y="40" width="280" height="226"/></clipPath>' +
      '</defs>' +
      '<rect width="' + W + '" height="' + H + '" class="bp-bg"/>' +
      '<rect width="' + W + '" height="' + H + '" fill="url(#mnsp-grid)"/>' +
      '<rect width="' + W + '" height="' + H + '" fill="url(#mnsp-grid5)"/>' +
      '<g class="bp-scene">' + scene.svg + '</g>' +
      callouts(result.items || [], scene.anchors, vb) +
      '</svg>';
  }

  var api = { draw: draw, anchorKey: anchorKey, ROLE_ANCHOR: ROLE_ANCHOR };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else global.MNSPDiagram = api;
})(typeof window !== 'undefined' ? window : globalThis);

/*
 * Mapping Network Hotspot & Antenna Setup Planner.
 *
 * Recommends a compatible antenna system from the store's catalogue and shows
 * only figures that can be calculated from published specifications:
 * feedline loss (manufacturer datasheets), net gain at the antenna, and the
 * geometric line-of-sight horizon. It deliberately makes no coverage, reward or
 * earnings claims.
 *
 * The logic (recommend, radioHorizonKm, pickVariantForLength, ...) is pure and
 * unit tested in Node. The UI mounts on every [data-mnsp] element and reads the
 * catalogue the Liquid section renders into <script data-mnsp-catalog>.
 */
(function (global) {
  'use strict';

  // Attenuation at 900 MHz, Times Microwave datasheets (typical, 25 °C):
  // LMR-400 12.8 dB/100 m, LMR-200 32.6 dB/100 m, LMR-100A 74.9 dB/100 m.
  var LOSS_DB_PER_M = { lmr400: 0.128, lmr200: 0.326, lmr100: 0.749 };
  // RAKwireless arrestor spec: ≤0.2 dB (0–2000 MHz).
  var ARRESTOR_DB = 0.2;
  var LAIRD_DB = 0.25; // Laird L350NN: <0.25 dB insertion loss at 1000 MHz
  // Allowance per mated N / RP-SMA connection or adaptor (stated in the UI as an allowance).
  var CONNECTION_DB = 0.1;
  // Magnetic base: 2 m LMR-200, N-female to RP-SMA-male (product spec).
  var BASE_CABLE_M = 2;
  // Window pass N-female to RP-SMA-male: 1.0 m LMR-100A (SKU LPV100NFSMRP1.0M).
  var WINDOW_PASS_M = 1.0;
  // Height of the device at the other end of the link for the horizon figure.
  var DEVICE_HEIGHT_M = 1.5;

  function round1(n) { return Math.round(n * 10) / 10; }
  function round2(n) { return Math.round(n * 100) / 100; }

  /**
   * Distance to the radio horizon between two antennas, in km, using the
   * standard 4/3-Earth refraction model: d = 4.12 × (√h1 + √h2), heights in m.
   * It is a geometric upper bound over smooth terrain, not a coverage estimate.
   */
  function radioHorizonKm(heightM, deviceHeightM) {
    var h2 = deviceHeightM == null ? DEVICE_HEIGHT_M : deviceHeightM;
    return round1(4.12 * (Math.sqrt(Math.max(heightM, 0)) + Math.sqrt(h2)));
  }

  /** Which antenna class suits the site, and the general RF reason. */
  function chooseAntennaClass(input) {
    if (input.location !== 'indoor' && input.directional) {
      return { role: 'antenna_directional', why: 'A flat-panel directional antenna concentrates its signal in one direction (toward a town, farm or valley) and covers little behind it. Aim it during installation.' };
    }
    if (input.location === 'indoor') {
      return { role: 'antenna_low', why: 'Indoors, a low-gain antenna radiates a wide vertical pattern, which suits short distances and signal passing through walls and windows.' };
    }
    var h = input.heightM;
    switch (input.environment) {
      case 'city':
        return h >= 15
          ? { role: 'antenna_mid', why: 'Mounted well above nearby rooftops, a mid-gain antenna balances distance with enough vertical spread to reach the streets below.' }
          : { role: 'antenna_low', why: 'Among buildings, a low-gain antenna\'s wider vertical pattern reaches up and down as well as outward, which generally suits cluttered city surroundings.' };
      case 'hilly':
        return h >= 15
          ? { role: 'antenna_low', why: 'From a high point above hills or valleys, a low-gain antenna\'s wider vertical pattern can still point signal down into terrain below. Higher gain flattens the pattern toward the horizon.' }
          : { role: 'antenna_mid', why: 'In rolling terrain, a mid-gain antenna is a common compromise between distance and vertical spread.' };
      case 'rural':
        return h >= 6
          ? { role: 'antenna_high', why: 'Over flat, open land with a clear view, higher gain concentrates signal toward the horizon, where most of the area is.' }
          : { role: 'antenna_mid', why: 'At lower heights, a mid-gain antenna avoids a beam so flat that it passes over nearby obstacles.' };
      default:
        return { role: 'antenna_mid', why: 'In suburbs and towns, a mid-gain omnidirectional antenna is the common choice, balancing distance with vertical spread.' };
    }
  }

  /** Parse "1 Metre", "12 Metres", "10 ft", "3m" into metres; null if none. */
  function parseLengthM(title) {
    if (!title) return null;
    var m = /(\d+(?:\.\d+)?)\s*(m|meter|metre|meters|metres)\b/i.exec(title);
    if (m) return parseFloat(m[1]);
    var f = /(\d+(?:\.\d+)?)\s*(ft|feet|foot|')/i.exec(title);
    if (f) return round2(parseFloat(f[1]) * 0.3048);
    return null;
  }

  /** Shortest in-stock variant that covers the run; else the longest in stock (flagged short). */
  function pickVariantForLength(variants, runM) {
    var pool = variants.filter(function (v) { return v.available; });
    if (!pool.length) return { variant: null, lengthM: null };
    var withLen = pool
      .map(function (v) { return { v: v, len: parseLengthM(v.title) }; })
      .filter(function (x) { return x.len !== null; })
      .sort(function (a, b) { return a.len - b.len; });
    if (!withLen.length) return { variant: pool[0], lengthM: null };
    for (var i = 0; i < withLen.length; i++) {
      if (withLen[i].len >= runM) return { variant: withLen[i].v, lengthM: withLen[i].len };
    }
    var longest = withLen[withLen.length - 1];
    return { variant: longest.v, lengthM: longest.len, short: true };
  }

  var ROLE_NAME = {
    antenna_low: 'low-gain antenna', antenna_mid: 'mid-gain antenna', antenna_high: 'high-gain antenna', antenna_directional: 'directional antenna',
    cable_rpsma: 'LMR-400 cable (N-female to RP-SMA male)', cable_nm: 'LMR-400 cable (N-female to N-male)', window_pass: 'window pass cable', window_pass_nm: 'N-male window pass cable',
    arrestor: 'lightning arrestor', arrestor_nf: 'lightning arrestor', adaptor_nm_nm: 'N-male to N-male adaptor', mount_indoor: 'magnetic antenna base',
    mount_wall: 'wall bracket', mount_mast: 'mast pole', enclosure_m1: 'SenseCAP M1 outdoor enclosure',
    enclosure_bobcat: 'Bobcat outdoor enclosure', enclosure_gateway: 'outdoor gateway enclosure',
    hotspot_m1: 'SenseCAP M1 hotspot', hotspot_nebra: 'Nebra hotspot'
  };

  // Why each hotspot is suggested. Facts from the product listings (2026-10-16): both are US915,
  // RP-SMA female antenna port, Ethernet or Wi-Fi, all sales final. No reward or earnings wording.
  var HOTSPOT_WHY = {
    hotspot_m1: 'SenseCAP M1 indoor LoRaWAN hotspot (US915). It has an RP-SMA antenna port for the cable above and connects to your router by Ethernet or Wi-Fi. Set it up with the official Helium Wallet app. All sales final.',
    hotspot_nebra: 'Nebra ROCK Pi indoor LoRaWAN hotspot (US915). It has an RP-SMA antenna port for the cable above and connects to your router by Ethernet or Wi-Fi. Nebra hasn\u2019t kept up its onboarding credits, so you may need to pay Helium\u2019s onboarding fee yourself (4,000,000 DC, about USD $40) or arrange it with Nebra. All sales final.'
  };

  /** First in-stock product in a role; null when none is in stock (never suggest unavailable items). */
  function pickProduct(catalog, role) {
    var list = (catalog[role] || []).filter(Boolean);
    if (!list.length) return null;
    for (var i = 0; i < list.length; i++) if (list[i].available && firstAvailableVariant(list[i])) return list[i];
    return null;
  }

  function firstAvailableVariant(p) {
    return (p.variants || []).find(function (v) { return v.available; }) || null;
  }

  /**
   * input: { location: indoor|attic|wall|roof, environment: city|suburban|rural|hilly,
   *          heightM, runM, hotspotPlacement: inside|outside, route: wall|window,
   *          hotspotModel: m1|gateway|bobcat|other, directional,
   *          needHotspot: bool (customer wants us to supply one), hotspotChoice: m1|nebra }
   * catalog: { role: [ { handle,title,url,image,available,gain?,variants:[{id,title,price,available}] } ] }
   */
  function recommend(input, catalog) {
    // A hotspot we supply in an outdoor enclosure is always the SenseCAP M1: its enclosure kit is made for it.
    var model = input.needHotspot ? 'm1' : input.hotspotModel;
    var indoor = input.location === 'indoor';
    // An enclosure is for a hotspot outdoors beside the antenna, so it isn't offered for attic setups.
    var hotspotOutside = !indoor && input.location !== 'attic' && input.hotspotPlacement === 'outside';
    var useWindow = !indoor && !hotspotOutside && input.route === 'window';
    var items = [];
    var losses = []; // { label, db }
    var chain = [];
    var notes = [];
    var unspecifiedLoss = null;

    function add(role, reason, variant) {
      var p = pickProduct(catalog, role);
      if (!p) return null; // Fraser: never show out-of-stock parts; callers pick an in-stock alternative
      var item = { role: role, product: p, variant: variant || firstAvailableVariant(p), reason: reason, quantity: 1 };
      items.push(item);
      return item;
    }
    function lose(label, db) { losses.push({ label: label, db: round2(db) }); }

    // Antenna
    var cls = chooseAntennaClass(input);
    var ant = add(cls.role, cls.why);
    if (!ant) {
      var altRoles = ['antenna_mid', 'antenna_low', 'antenna_high'];
      for (var ai = 0; ai < altRoles.length && !ant; ai++) {
        if (altRoles[ai] !== cls.role) { cls = { role: altRoles[ai], why: cls.why }; ant = add(altRoles[ai], cls.why); }
      }
    }
    var gain = ant && ant.product.gain != null ? Number(ant.product.gain) : null;
    var directional = cls.role === 'antenna_directional';
    chain.push(ant ? (directional ? 'Directional antenna (N-female)' : 'Antenna (N-male)') : 'Antenna');

    if (indoor) {
      var base = add('mount_indoor', 'Indoor-only magnetic base with a built-in 2 m low-loss cable (N-female to RP-SMA-male). Place the antenna at the window with the clearest outside view.');
      if (base) {
        chain.push('Magnetic base, 2 m LMR-200');
        lose('2 m LMR-200 (base cable)', BASE_CABLE_M * LOSS_DB_PER_M.lmr200);
        lose('2 connections', 2 * CONNECTION_DB);
        notes.push('The base cable is 2 m long, so the hotspot needs to sit within 2 m of the antenna.');
      } else {
        // No magnetic base on hand: a short LMR-400 lead joins the antenna (N-male) to the hotspot (RP-SMA).
        var ic = pickProduct(catalog, 'cable_rpsma');
        if (ic) {
          var ip = pickVariantForLength(ic.variants, BASE_CABLE_M);
          add('cable_rpsma', 'Short LMR-400 low-loss cable (N-female to RP-SMA-male) from the antenna to your hotspot. Stand the antenna upright at the window with the clearest outside view.', ip.variant);
          chain.push('LMR-400 ' + fmtLen(ip.lengthM));
          if (ip.lengthM != null) lose(fmtLen(ip.lengthM) + ' LMR-400', ip.lengthM * LOSS_DB_PER_M.lmr400);
          lose('2 connections', 2 * CONNECTION_DB);
        }
      }
    } else {
      var groundNote = ' Bond its ground lug to your building\'s grounding system per local electrical code.';
      var rak = pickProduct(catalog, 'arrestor');
      var laird = rak ? null : pickProduct(catalog, 'arrestor_nf');
      // Fraser prefers no adaptor with the Laird: an N-male window pass screws straight onto it.
      // Not possible for a directional antenna (N-female) or an enclosure (N-female bulkhead).
      var wpNm = laird && !directional && !hotspotOutside ? pickProduct(catalog, 'window_pass_nm') : null;
      var lairdDirect = !!wpNm;
      if (lairdDirect) {
        var outRunM = Math.max(input.runM - WINDOW_PASS_M, 0);
        if (outRunM > 0) {
          var lnm = pickProduct(catalog, 'cable_nm');
          if (lnm) {
            var lp = pickVariantForLength(lnm.variants, outRunM);
            add('cable_nm', 'LMR-400 low-loss cable (N-female to N-male) from the antenna down to the arrestor where the cable enters the building.', lp.variant);
            chain.push('LMR-400 ' + fmtLen(lp.lengthM));
            if (lp.lengthM != null) lose(fmtLen(lp.lengthM) + ' LMR-400', lp.lengthM * LOSS_DB_PER_M.lmr400);
            if (lp.short) notes.push('Our longest cable is ' + fmtLen(lp.lengthM) + ', shorter than your outdoor run. Move the hotspot closer to the antenna, or put it outside in an enclosure beside the antenna.');
          }
        }
        add('arrestor_nf', 'Laird lightning surge arrestor (N-female both ends, rated 0\u20131000 MHz). Fit it where the cable enters the building.' + groundNote);
        chain.push('Laird arrestor (N-female/N-female)');
        lose('Laird arrestor (spec <0.25 dB at 1000 MHz)', LAIRD_DB);
        add('window_pass_nm', useWindow
          ? 'Flat 1 m LMR-100A cable (N-male to RP-SMA-male). It screws straight onto the Laird arrestor, so no adaptor is needed, and runs under a closed window or door to your hotspot.'
          : 'Flat 1 m LMR-100A cable (N-male to RP-SMA-male) from the arrestor through your wall entry to the hotspot. It screws straight onto the Laird arrestor, so no adaptor is needed.');
        chain.push('Window pass, 1 m (N-male to RP-SMA-male)');
        lose('1 m LMR-100A window pass', WINDOW_PASS_M * LOSS_DB_PER_M.lmr100);
        lose((outRunM > 0 ? 3 : 2) + ' connections', (outRunM > 0 ? 3 : 2) * CONNECTION_DB);
      } else if (laird) {
        // Laird is N-female on both ends, so an N-male/N-male adaptor joins it to the next N-female
        // (and a second one joins a directional antenna's N-female to the arrestor).
        add('arrestor_nf', 'Laird lightning surge arrestor (N-female both ends, rated 0\u20131000 MHz) for the outdoor antenna line.' + groundNote);
        var ad = add('adaptor_nm_nm', directional
          ? 'Two N-male to N-male adaptors: one joins the directional antenna (N-female) to the arrestor, one joins the arrestor to the cable.'
          : 'N-male to N-male adaptor. The Laird arrestor is N-female on both ends, so this joins it to the next cable.');
        if (ad && directional) ad.quantity = 2;
        if (directional) { chain.push('N-male/N-male adaptor'); lose('Adaptor', CONNECTION_DB); }
        chain.push('Laird arrestor (N-female/N-female)');
        lose('Laird arrestor (spec <0.25 dB at 1000 MHz)', LAIRD_DB);
        chain.push('N-male/N-male adaptor');
        lose('Adaptor', CONNECTION_DB);
      } else {
        var arr = add('arrestor', 'Lightning arrestor (N-male to N-female) for the outdoor antenna line.' + groundNote);
        if (arr) {
          chain.push('Lightning arrestor');
          lose('Lightning arrestor (spec \u22640.2 dB)', ARRESTOR_DB);
        }
        if (directional) {
          add('adaptor_nm_nm', 'N-male to N-male adaptor. The directional antenna has a female connector, so this joins the arrestor to the next cable.');
          chain.push('N-male/N-male adaptor');
          lose('Adaptor', CONNECTION_DB);
        }
      }

      if (lairdDirect) {
        // chain already complete
      } else if (hotspotOutside) {
        var encRole = model === 'm1' ? 'enclosure_m1' : model === 'bobcat' ? 'enclosure_bobcat' : 'enclosure_gateway';
        var enc = add(encRole, 'Weatherproof IP67 enclosure kit for your hotspot, with PoE injector and splitter, pole-mount kit and an antenna pigtail (N-female to RP-SMA-male), so the hotspot sits beside the antenna.');
        if (enc) chain.push('Enclosure pigtail (included)');
        if (model === 'other') notes.push('This enclosure kit fits RAK hotspots, RAK7244 and most similar gateways. Please contact us to confirm it fits your hotspot before ordering.');
        lose('2 connections', 2 * CONNECTION_DB);
        unspecifiedLoss = 'the enclosure\'s included pigtail (length not specified by the manufacturer)';
      } else if (useWindow) {
        var outdoorRunM = Math.max(input.runM - WINDOW_PASS_M, 0);
        if (outdoorRunM > 0) {
          var cnm = pickProduct(catalog, 'cable_nm');
          if (cnm) {
            var pick = pickVariantForLength(cnm.variants, outdoorRunM);
            add('cable_nm', 'LMR-400 low-loss cable (N-female to N-male) for the outdoor run from the arrestor to the window.', pick.variant);
            chain.push('LMR-400 ' + fmtLen(pick.lengthM));
            if (pick.lengthM != null) lose(fmtLen(pick.lengthM) + ' LMR-400', pick.lengthM * LOSS_DB_PER_M.lmr400);
            if (pick.short) notes.push('Our longest cable is ' + fmtLen(pick.lengthM) + ', shorter than your outdoor run. Move the hotspot closer to the antenna, or put it outside in an enclosure beside the antenna.');
          }
        }
        add('window_pass', 'Flat 1 m LMR-100A window pass (N-female to RP-SMA-male). It runs under a closed window or door, so you don\'t need to drill.');
        chain.push('Window pass, 1 m');
        lose('1 m LMR-100A window pass', WINDOW_PASS_M * LOSS_DB_PER_M.lmr100);
        lose((outdoorRunM > 0 ? 3 : 2) + ' connections', (outdoorRunM > 0 ? 3 : 2) * CONNECTION_DB);
      } else {
        var c = pickProduct(catalog, 'cable_rpsma');
        if (c) {
          var vp = pickVariantForLength(c.variants, input.runM);
          add('cable_rpsma', 'LMR-400 low-loss cable (N-female to RP-SMA-male) from the arrestor to your hotspot.', vp.variant);
          chain.push('LMR-400 ' + fmtLen(vp.lengthM));
          if (vp.lengthM != null) lose(fmtLen(vp.lengthM) + ' LMR-400', vp.lengthM * LOSS_DB_PER_M.lmr400);
          lose('2 connections', 2 * CONNECTION_DB);
          if (vp.short) notes.push('Our longest cable is ' + fmtLen(vp.lengthM) + ', shorter than your ' + input.runM + ' m run. Move the hotspot closer to the antenna, or put it outside in an enclosure beside the antenna.');
        }
      }

      var addMount = function (role, reason) {
        if (add(role, reason)) return;
        var other = role === 'mount_wall' ? 'mount_mast' : 'mount_wall';
        add(other, other === 'mount_wall' ? 'L-type wall bracket that holds the antenna away from the wall or a mast.' : 'U-shaped hoisting pole for roof, chimney or mast mounting.');
      };
      if (input.location === 'attic') {
        addMount('mount_wall', 'Wall bracket to stand the antenna off a rafter or gable wall.');
        notes.push('Metal roofing, solar panels and foil-backed insulation block radio signals. A gable-end wall is usually the clearest spot in an attic.');
      } else if (input.location === 'wall') {
        addMount('mount_wall', 'L-type wall bracket that holds the antenna away from the wall.');
      } else {
        addMount('mount_mast', 'U-shaped hoisting pole for roof, chimney or mast mounting.');
      }
    }
    if (input.needHotspot) {
      var wantHs = hotspotOutside || input.hotspotChoice !== 'nebra' ? 'hotspot_m1' : 'hotspot_nebra';
      if (hotspotOutside && input.hotspotChoice === 'nebra') notes.push('For a hotspot in an outdoor enclosure we suggest the SenseCAP M1, because the enclosure kit is made for it.');
      var hs = add(wantHs, HOTSPOT_WHY[wantHs]);
      if (!hs && !hotspotOutside) {
        var altHs = wantHs === 'hotspot_m1' ? 'hotspot_nebra' : 'hotspot_m1';
        add(altHs, HOTSPOT_WHY[altHs]);
      }
    }
    chain.push(hotspotOutside ? 'Hotspot in enclosure (RP-SMA)' : 'Hotspot (RP-SMA)');

    var totalLoss = round1(losses.reduce(function (s, l) { return s + l.db; }, 0));
    if (totalLoss > 3) notes.push('Feedline loss is over 3 dB, which means less than half the hotspot\'s power reaches the antenna. A shorter run or an outdoor enclosure would reduce it.');

    var total = items.reduce(function (s, it) {
      return s + (it.product.available && it.variant ? Number(it.variant.price) * it.quantity : 0);
    }, 0);

    return {
      antennaGain: gain,
      feedlineLossDb: totalLoss,
      powerDeliveredPct: Math.round(Math.pow(10, -totalLoss / 10) * 100),
      losses: losses,
      unspecifiedLoss: unspecifiedLoss,
      netGainDb: gain == null ? null : round1(gain - totalLoss),
      horizonKm: radioHorizonKm(input.heightM),
      chain: chain,
      items: items,
      notes: notes,
      total: round2(total)
    };
  }

  function fmtLen(m) {
    if (m == null) return '';
    return (Math.round(m * 10) / 10) + ' m';
  }

  var core = {
    recommend: recommend,
    radioHorizonKm: radioHorizonKm,
    chooseAntennaClass: chooseAntennaClass,
    parseLengthM: parseLengthM,
    pickVariantForLength: pickVariantForLength,
    LOSS_DB_PER_M: LOSS_DB_PER_M
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = core;
    return;
  }

  // ---------------------------------------------------------------- UI

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(n, currency) {
    try {
      // Fraser: every price says its currency (CAD), e.g. "$5.99 CAD".
      var code = currency || 'CAD';
      return new Intl.NumberFormat('en-CA', { style: 'currency', currency: code, currencyDisplay: 'narrowSymbol' }).format(n) + ' ' + code;
    } catch (e) { return Number(n).toFixed(2) + ' ' + (currency || 'CAD'); }
  }

  // Short URL keys so a plan can be shared or bookmarked: ?loc=wall&env=suburban&h=6...
  var PARAMS = { loc: 'location', env: 'environment', h: 'height', at: 'placement', via: 'route', run: 'run', model: 'model', own: 'own', pick: 'pick', dir: 'directional' };

  function setField(f, name, value) {
    var el = f.elements[name];
    if (!el) return;
    if (el.type === 'checkbox') { el.checked = value === '1'; return; }
    if (el.length && !el.options) { // radio group
      for (var i = 0; i < el.length; i++) if (el[i].value === value && !el[i].closest('[hidden]')) el[i].checked = true;
      return;
    }
    if (el.options) { for (var j = 0; j < el.options.length; j++) if (el.options[j].value === value) el.value = value; return; }
    if (el.type === 'range') {
      var n = parseFloat(value);
      if (!isNaN(n)) el.value = Math.min(Math.max(n, +el.min), +el.max);
      return;
    }
  }

  function applyParams(root) {
    var f = root.querySelector('form');
    var q;
    try { q = new URLSearchParams(global.location.search); } catch (e) { return false; }
    var any = false;
    Object.keys(PARAMS).forEach(function (k) { if (q.has(k)) { setField(f, PARAMS[k], q.get(k)); any = true; } });
    return any;
  }

  function planQuery(root) {
    var f = root.querySelector('form');
    var q = [];
    Object.keys(PARAMS).forEach(function (k) {
      var el = f.elements[PARAMS[k]];
      if (!el) return;
      var v = el.type === 'checkbox' ? (el.checked ? '1' : '0') : el.value;
      if (v !== '' && v != null) q.push(k + '=' + encodeURIComponent(v));
    });
    return q.join('&');
  }

  function planUrl(root) {
    var loc = global.location;
    return loc.origin + loc.pathname + '?' + planQuery(root) + '#mnsp';
  }

  function readForm(root) {
    var f = root.querySelector('form');
    var get = function (n) { var el = f.elements[n]; return el ? el.value : ''; };
    var checked = function (n) { var el = f.elements[n]; return !!(el && el.checked); };
    return {
      location: get('location'),
      environment: get('environment'),
      heightM: parseFloat(get('height')) || 3,
      runM: parseFloat(get('run')) || 1,
      hotspotPlacement: get('placement'),
      route: get('route'),
      hotspotModel: get('model'),
      directional: checked('directional'),
      needHotspot: get('own') === 'need',
      hotspotChoice: get('pick')
    };
  }

  function syncVisibility(root, input) {
    var outdoor = input.location !== 'indoor';
    var canMountOutside = outdoor && input.location !== 'attic';
    var outside = canMountOutside && input.hotspotPlacement === 'outside';
    var show = function (sel, on) { root.querySelectorAll(sel).forEach(function (el) { el.hidden = !on; }); };
    show('[data-show="outdoor"]', outdoor);
    show('[data-show="outside-ok"]', canMountOutside);
    show('[data-show="hotspot-outside"]', outside && !input.needHotspot);
    show('[data-show="cable-run"]', outdoor && !outside);
    show('[data-show="need"]', input.needHotspot);
    var hv = root.querySelector('[data-height-value]');
    if (hv) hv.textContent = input.heightM + ' m';
    var rv = root.querySelector('[data-run-value]');
    if (rv) rv.textContent = input.runM + ' m';
  }

  /** Show live prices on the hotspot choices, and hide any hotspot with no on-hand stock. */
  function decorateHotspots(root, catalog, currency) {
    var anyHotspot = false;
    root.querySelectorAll('[data-hotspot-role]').forEach(function (label) {
      var role = label.getAttribute('data-hotspot-role');
      var p = pickProduct(catalog, role);
      var v = p && firstAvailableVariant(p);
      label.hidden = !v;
      if (v) {
        anyHotspot = true;
        var price = label.querySelector('[data-price]');
        if (price) price.textContent = money(v.price, currency);
      }
    });
    // No hotspot on hand: drop the "I need one" choice entirely (Fraser: never show unavailable items).
    var need = root.querySelector('[data-own-need]');
    if (need) need.hidden = !anyHotspot;
    var f = root.querySelector('form');
    if (!anyHotspot && f.elements.own) setField(f, 'own', 'have');
    var pick = f.elements.pick;
    if (pick && pick.length) {
      var cur = Array.prototype.find.call(pick, function (r) { return r.checked; });
      if (!cur || cur.closest('[hidden]')) {
        var first = Array.prototype.find.call(pick, function (r) { return !r.closest('[hidden]'); });
        if (first) first.checked = true;
      }
    }
  }

  function sceneKey(input) {
    return [input.location, input.hotspotPlacement, input.route, input.environment].join('|');
  }

  /**
   * Swap in the new drawing. A different scene (location, surroundings, hotspot placement, cable
   * route) cross-fades over the old one; any other click redraws the cable and callouts in place.
   * Dragging a slider just updates, so it stays smooth.
   */
  function drawDiagram(root, input, r, animate) {
    var host = root.querySelector('[data-mnsp-bp]');
    if (!host || !global.MNSPDiagram) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = global.MNSPDiagram.draw(input, r);
    var next = tmp.firstChild;
    var key = sceneKey(input);
    var sceneChanged = root.__mnspScene !== key;
    root.__mnspScene = key;
    var prev = host.querySelectorAll('svg');
    if (!animate || !prev.length) {
      prev.forEach(function (el) { el.remove(); });
      if (animate) next.classList.add('is-redrawn');
      host.appendChild(next);
      return;
    }
    if (sceneChanged) {
      // Keep only the newest old drawing underneath, then fade the new one in over it.
      for (var i = 0; i < prev.length - 1; i++) prev[i].remove();
      var under = prev[prev.length - 1];
      under.classList.remove('is-over');
      next.classList.add('is-entering', 'is-over');
      host.appendChild(next);
      next.addEventListener('animationend', function done(e) {
        if (e.target !== next) return; // the fade of the whole drawing, not the cable or numbers
        next.removeEventListener('animationend', done);
        if (under.parentNode) under.remove();
        next.classList.remove('is-over');
      });
    } else {
      prev.forEach(function (el) { el.remove(); });
      next.classList.add('is-redrawn');
      host.appendChild(next);
    }
  }

  function render(root, catalog, settings, animate) {
    var input = readForm(root);
    syncVisibility(root, input);
    var r = recommend(input, catalog);
    drawDiagram(root, input, r, animate);
    var out = root.querySelector('[data-mnsp-result]');
    var currency = settings.currency;

    if (settings.syncUrl && global.history && global.history.replaceState) {
      try { global.history.replaceState(global.history.state, '', global.location.pathname + '?' + planQuery(root) + global.location.hash); } catch (e) { /* ignore */ }
    }

    var rows = r.items.map(function (it, i) {
      var p = it.product;
      var vTitle = it.variant && it.variant.title && it.variant.title !== 'Default Title' ? esc(it.variant.title) : '';
      var gainTag = p.gain != null ? '<span class="mnsp-tag">' + esc(p.gain) + ' dBi</span>' : '';
      return '<li class="mnsp-item" data-n="' + (i + 1) + '">' +
        '<label class="mnsp-item__check">' +
          '<input type="checkbox" data-item="' + i + '" checked aria-label="Include ' + esc(p.title) + '">' +
          '<span class="mnsp-num" aria-hidden="true">' + (i + 1) + '</span>' +
        '</label>' +
        (p.image ? '<img class="mnsp-item__img" src="' + esc(p.image) + '" alt="" loading="lazy" width="64" height="64">' : '<span class="mnsp-item__img" aria-hidden="true"></span>') +
        '<div class="mnsp-item__body">' +
          '<a class="mnsp-item__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' + gainTag +
          (vTitle ? '<span class="mnsp-item__variant">' + vTitle + '</span>' : '') +
          '<p class="mnsp-item__why">' + esc(it.reason) + '</p>' +
        '</div>' +
        '<div class="mnsp-item__price">' + (it.quantity > 1 ? it.quantity + ' × ' : '') + money(it.variant.price, currency) + '</div>' +
      '</li>';
    }).join('');

    var lossRows = r.losses.map(function (l) {
      return '<tr><td>' + esc(l.label) + '</td><td>' + l.db.toFixed(2) + ' dB</td></tr>';
    }).join('');
    var notes = r.notes.map(function (n) { return '<li>' + esc(n) + '</li>'; }).join('');
    var lossValue = r.feedlineLossDb + ' dB' + (r.unspecifiedLoss ? '*' : '');

    out.innerHTML =
      '<div class="mnsp-stats" role="group" aria-label="Calculated figures">' +
        '<div class="mnsp-stat"><span class="mnsp-stat__value">' + (r.antennaGain == null ? '–' : r.antennaGain + ' dBi') + '</span><span class="mnsp-stat__label">Antenna gain (manufacturer spec)</span></div>' +
        '<div class="mnsp-stat"><span class="mnsp-stat__value">' + lossValue + '</span><span class="mnsp-stat__label">Feedline loss</span></div>' +
        '<div class="mnsp-stat"><span class="mnsp-stat__value">' + r.horizonKm + ' km</span><span class="mnsp-stat__label">Line-of-sight horizon</span></div>' +
      '</div>' +
      '<p class="mnsp-fine">The horizon is the furthest an antenna at ' + input.heightM + ' m can see a device 1.5 m off the ground over perfectly smooth terrain. It is a geometric limit, not a coverage estimate. Buildings, trees and terrain usually limit real-world range to much less.' +
        (r.unspecifiedLoss ? ' *Plus ' + esc(r.unspecifiedLoss) + '.' : '') + '</p>' +
      (notes ? '<ul class="mnsp-notes">' + notes + '</ul>' : '') +
      '<h3 class="mnsp-h3">Your parts <span class="mnsp-h3__aside">numbers match the drawing</span></h3>' +
      (rows ? '<ul class="mnsp-items">' + rows + '</ul>' : '<p class="mnsp-fine">Browse our antennas and cables for this setup.</p>') +
      '<div class="mnsp-cartbar">' +
        '<div><span class="mnsp-total" data-total>' + money(r.total, currency) + '</span><span class="mnsp-fine"> Untick anything you already own.</span></div>' +
        '<button type="button" class="mnsp-btn" data-add' + (r.items.length ? '' : ' disabled') + '>Add selected to cart</button>' +
      '</div>' +
      '<p class="mnsp-status" role="status" aria-live="polite" data-status></p>' +
      '<div class="mnsp-share"><button type="button" class="mnsp-link" data-share>Copy a link to this plan</button><span class="mnsp-fine">Send it to your installer, or save it for later.</span></div>' +
      '<details class="mnsp-math"><summary>How it connects and how we calculate</summary>' +
        '<ol class="mnsp-chain">' + r.chain.map(function (c) { return '<li>' + esc(c) + '</li>'; }).join('') + '</ol>' +
        '<table class="mnsp-loss"><tbody>' + lossRows + '<tr class="mnsp-loss__total"><td>Feedline loss</td><td>' + r.feedlineLossDb.toFixed(1) + ' dB</td></tr><tr><td>Share of transmit power reaching the antenna' + (r.unspecifiedLoss ? ' (before the pigtail)' : '') + '</td><td>≈' + r.powerDeliveredPct + '%</td></tr></tbody></table>' +
        '<p>Cable loss is the manufacturer\'s typical attenuation at 900 MHz (Times Microwave LMR-400 12.8 dB/100 m, LMR-200 32.6 dB/100 m, LMR-100A 74.9 dB/100 m), multiplied by the cable length. The arrestor uses its rated loss (RAKwireless ≤0.2 dB, Laird under 0.25 dB at 1000 MHz). Each connection or adaptor gets an allowance of 0.1 dB.</p>' +
        '<p>The line-of-sight horizon is d = 4.12 × (√h<sub>antenna</sub> + √1.5) km, the standard radio-horizon formula with 4/3-Earth refraction.</p>' +
      '</details>';

    out.querySelectorAll('img.mnsp-item__img').forEach(function (img) {
      img.addEventListener('error', function () {
        var ph = document.createElement('span');
        ph.className = 'mnsp-item__img';
        ph.setAttribute('aria-hidden', 'true');
        img.replaceWith(ph);
      });
    });

    // Point at a part in the drawing when its row is hovered or focused, and dim parts the customer unticks.
    var svgs = root.querySelectorAll('[data-mnsp-bp] svg');
    var svg = svgs[svgs.length - 1];
    function callout(n) { return svg ? svg.querySelector('.bp-callout[data-n="' + n + '"]') : null; }
    out.querySelectorAll('.mnsp-item').forEach(function (li) {
      var n = li.getAttribute('data-n');
      var on = function () { var c = callout(n); if (c) c.classList.add('is-hot'); };
      var off = function () { var c = callout(n); if (c) c.classList.remove('is-hot'); };
      li.addEventListener('mouseenter', on); li.addEventListener('mouseleave', off);
      li.addEventListener('focusin', on); li.addEventListener('focusout', off);
    });

    function selected() {
      return r.items.filter(function (it, i) {
        var cb = out.querySelector('input[data-item="' + i + '"]');
        return cb && cb.checked && it.variant;
      });
    }

    out.querySelectorAll('input[data-item]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        var n = Number(cb.getAttribute('data-item')) + 1;
        var c = callout(n);
        if (c) c.classList.toggle('is-owned', !cb.checked);
        var t = selected().reduce(function (s, it) { return s + Number(it.variant.price) * it.quantity; }, 0);
        out.querySelector('[data-total]').textContent = money(t, currency);
        out.querySelector('[data-add]').disabled = selected().length === 0;
      });
    });

    out.querySelector('[data-share]').addEventListener('click', function () {
      var url = planUrl(root);
      var status = out.querySelector('[data-status]');
      var done = function () { status.textContent = 'Link copied. Anyone who opens it sees this plan.'; };
      if (global.navigator && global.navigator.clipboard && global.navigator.clipboard.writeText) {
        global.navigator.clipboard.writeText(url).then(done, function () { status.textContent = url; });
      } else {
        status.textContent = url;
      }
    });

    out.querySelector('[data-add]').addEventListener('click', function () {
      var btn = this;
      var picked = selected();
      if (!picked.length) return;
      var status = out.querySelector('[data-status]');
      var rootPath = global.Shopify && global.Shopify.routes ? global.Shopify.routes.root : '/';
      btn.disabled = true;
      status.textContent = 'Adding to cart…';
      var body = { items: picked.map(function (it) { return { id: it.variant.id, quantity: it.quantity }; }) };
      var addFn = settings.addToCart || function (payload) {
        return fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        }).then(function (res) {
          return res.json().then(function (j) {
            if (!res.ok) throw new Error(j.description || 'Could not add to cart');
            return j;
          });
        });
      };
      Promise.resolve(addFn(body)).then(function (resp) {
        status.textContent = 'Added ' + picked.length + ' item' + (picked.length > 1 ? 's' : '') + ' to your cart.';
        // Dawn's pub/sub cart event (cart drawer and bubble listen to it).
        if (typeof global.publish === 'function' && global.PUB_SUB_EVENTS) {
          global.publish(global.PUB_SUB_EVENTS.cartUpdate, { source: 'mn-setup-planner', cartData: resp });
        }
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'mn-setup-planner', data: resp } }));
        if (settings.goToCart) global.location.href = rootPath + 'cart';
        else btn.disabled = false;
      }).catch(function (err) {
        status.textContent = err.message + '. Please try again, or add the items from their product pages.';
        btn.disabled = false;
      });
    });
  }

  function mount(root) {
    if (root.__mnsp) return;
    root.__mnsp = true;
    var catEl = root.querySelector('script[data-mnsp-catalog]');
    var catalog = {};
    try { catalog = catEl ? JSON.parse(catEl.textContent) : {}; } catch (e) { catalog = {}; }
    var designMode = !!(global.Shopify && global.Shopify.designMode);
    var settings = {
      currency: root.getAttribute('data-currency') || 'CAD',
      goToCart: root.getAttribute('data-go-to-cart') === 'true',
      syncUrl: !designMode && root.getAttribute('data-sync-url') !== 'false',
      addToCart: global.__mnspAddToCart // preview hook only
    };
    var form = root.querySelector('form');
    applyParams(root);
    decorateHotspots(root, catalog, settings.currency);
    // Sliders redraw live while dragging (no animation); every click on a choice animates.
    form.addEventListener('input', function (e) { if (e.target.type === 'range') render(root, catalog, settings, false); });
    form.addEventListener('change', function (e) { render(root, catalog, settings, e.target.type !== 'range'); });
    form.addEventListener('submit', function (e) { e.preventDefault(); });
    render(root, catalog, settings, true);
  }

  function init() { document.querySelectorAll('[data-mnsp]').forEach(mount); }
  global.MNSetupPlanner = core;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})(typeof window !== 'undefined' ? window : globalThis);


  } catch(e) { console.error(e); }
})();
})();
